<template>
  <div>
    <div class="flex mb-5">
      <div class="w-10/12">
        <h1 class="text-xl font-bold text-gray-700">Price Groups</h1>
      </div>
      <div class="w-2/12">
        <base-button-primary @click="showModal = !showModal" class="float-right"
          >New Group</base-button-primary
        >
      </div>
    </div>

    <el-table
      :data="priceGroups"
      :default-sort="{ prop: 'photo_count', order: 'ascending' }"
      style="width: 100%"
    >
      <el-table-column prop="photo_count" label="Photo Count" sortable>
      </el-table-column>
      <el-table-column label="Price" sortable>
        <template slot-scope="scope">
          ${{ getNumberFormatted(scope.row.price) }}
        </template>
      </el-table-column>

      <el-table-column label="">
        <template slot-scope="scope">
          <base-button-white-extra-small
            @click="handleDelete(scope.row)"
            class="ml-3"
          >
            Delete
          </base-button-white-extra-small>
        </template>
      </el-table-column>
    </el-table>

    <base-modal :show="showModal" @close="showModal = false" @save="save">
      <template v-slot:header> Price Group </template>
      <template v-slot:main>
        <div class="grid grid-cols-2 gap-4">
          <div class="col">
            <base-label>Count</base-label>
            <base-input v-model="group.photo_count" />
          </div>

          <div class="col">
            <base-label>Price</base-label>
            <base-currency :value="group.price" @change="group.price = $event">
            </base-currency>
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import Validator from "../../components/common/Validator";
import currency from "../../mixins/currency";

export default {
  name: "PriceGroups",
  mixins: [currency],
  data() {
    return {
      showModal: false,
      group: {
        price: 0,
        photo_count: "",
      },
    };
  },
  methods: {
    handleDelete(row) {
      if (confirm("Are you sure you want to delete this price group?")) {
        this.$store
          .dispatch("outfitter/delete_price_group", row.id)
          .then((resp) => {
            if (!resp.success) return;

            this.$store.dispatch(
              "outfitter/reload_outfitter",
              this.$store.getters["auth/outfitterId"]
            );
            this.$notify({
              title: "Price Group",
              message: "Price Group has been deleted",
              type: "success",
            });
          });
      }
    },

    save() {
      if (
        !Validator([
          { field: this.group.price, name: "Price" },
          { field: this.group.photo_count, name: "Photo Count" },
        ])
      ) {
        return;
      }
      this.group.outfitter_id = this.$store.getters["auth/outfitterId"];
      this.$store
        .dispatch("outfitter/save_price_group", this.group)
        .then((resp) => {
          if (!resp.success) return;

          this.$store.dispatch(
            "outfitter/reload_outfitter",
            this.$store.getters["auth/outfitterId"]
          );
          this.$notify({
            title: "Price Group",
            message: "Data Saved",
            type: "success",
          });
          this.showModal = false;
          this.group = {
            price: 0,
            photo_count: "",
          };
        });
    },
  },
  computed: {
    priceGroups: function () {
      return this.$store.getters["outfitter/getPriceGroups"];
    },
  },
  mounted() {},
};
</script>
